import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IFileUploadErrorProps {
  error: string;
}

export const FileUploadError: React.FC<IFileUploadErrorProps> = ({ error }) => {
  return (
    <div className={styles['error']}>
      <ArticleParagraph2 color="text-negative-default">{error}</ArticleParagraph2>
    </div>
  );
};

FileUploadError.displayName = 'FileUploadError';
